import request from '../request'

export const usageApi = {
  // 获取使用记录
  getRecords(params) {
    return request.post('/v1/usage/skill-records', params)
  },

  // 获取已安装技能及调用次数--概览
  getInstalledSkillsOverview() {
    return request.post('/v1/skill/overview', {})
  },

  // 获取已安装技能列表 v1/skill/installed
  getInstalledSkills() {
    return request.post('/v1/skill/installed', {})
  }
}
